module.exports = __webpack_public_path__ + "static/media/skybox external_view_m.4dda45e9.jpg";